module.exports = __webpack_public_path__ + "img/Pelletsverbrauch.3b09d25.webp";